/*
 * @Descripttion: 组件参数配置模型
 * @Author: zenghua.wang
 * @Date: 2021-04-10 13:54:01
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-11 16:43:42
 */
import { cardConfig, buttonConfig } from '@/dragComponents/model/default.js'

// apis配置项
const apis = {
  request: true,
  reqMethod: 'GET',
  reqParams: [],
  refresh: false,
  refreshTime: 0,
  column: []
}

// 权限
const auths = {
  authType: '',
  roleList: []
}

// 颜色
const colors = {
  defaultColor: true,
  loopColor: true,
  color: [],
  isLinear: false,
  colorList: []
}

// 超链接
const hyperlink = {
  isLink: false,
  url: '',
  target: '_self'
}

// 图表配置项
const echarts = {
  title: {
    titleShow: true,
    titleLeft: 'left',
    titleTop: 10,
    titleText: '',
    titleTextColor: '#333',
    titleTextFontSize: 12,
    titleSubtext: '',
    titleSubtextColor: '#999',
    titleSubtextFontSize: 10
  },
  grid: {
    gridTop: 80,
    gridLeft: 80,
    gridRight: 80,
    gridBottom: 80,
    gridContainLabel: true
  },
  center: {
    centerX: 50,
    centerY: 55,
    centerR: 70,
    startRadius: 30,
    endRadius: 60
  },
  label: {
    unit: '',
    lineColor: '#666',
    lineFontSize: 10,
    labelShow: true,
    labelShowColor: '#666',
    labelShowFontSize: 10,
    labelShowFontWeight: 'normal'
  },
  tooltip: {
    tipShow: false,
    tipColor: '#666',
    tipFontSize: 10,
    tipFormatter: ''
  },
  legend: {
    legendShow: true,
    legendOrient: 'horizontal',
    legendTop: 2,
    legendLeft: 'center',
    legendColor: '#333',
    legendFontSize: 10
  },
  xAxis: {
    xAxisName: '',
    xAxisNameColor: '#333',
    xAxisNameFontSize: 10,
    xAxisShow: true,
    xAxisInverse: false,
    xAxisInterval: false,
    xAxisLine: true,
    xAxisTickShow: true,
    xAxisLabelShow: true,
    xAxisLabelRotate: 0,
    xAxisLabelFormatter: '{value}',
    xAxisSplitLineShow: false
  },
  yAxis: {
    yAxisName: '',
    yAxisNameColor: '#333',
    yAxisNameFontSize: 10,
    yAxisShow: true,
    yAxisInverse: false,
    yAxisInterval: false,
    yAxisLine: true,
    yAxisTickShow: true,
    yAxisLabelShow: true,
    yAxisLabelRotate: 0,
    yAxisLabelFormatter: '{value}',
    yAxisSplitLineShow: false
  },
  gauge: {
    startAngle: 220,
    endAngle: -40,
    min: 0,
    max: 100,
    unit: '',
    splitNumber: 10,
    progressShow: true,
    progressColor: '#3b9cd9',
    lineWidth: 10,
    lineColor: '#E6EBF8',
    roundCap: false,
    labelShow: true,
    labelFontSize: 12,
    labelColor: '#666',
    labelDistance: 15,
    labelFormatter: '',
    axisTickShow: false,
    axisTickLength: 8,
    axisTickWidth: 1,
    axisTickColor: '#999',
    splitLineShow: true,
    splitLineLength: 10,
    splitLineWidth: 2,
    splitLineColor: '#999',
    pointerShow: true,
    pointerLength: 40,
    pointerWidth: 6,
    pointerColor: '#3b9cd9',
    anchorShow: false,
    anchorSize: 16,
    anchorColor: '#3b9cd9',
    gaugeTitleShow: true,
    gaugeTitleColor: '#666',
    gaugeTitleFontSize: 12,
    gaugeTitleCenter: 50,
    detailShow: true,
    detailFontSize: 20,
    detailColor: '',
    detailCenter: 30,
    detailFormatter: '{value}'
  },
  map: {
    map: 'china',
    zoom: 1,
    labelShow: true,
    labelFontSize: 10,
    labelColor: '#333',
    labelHightColor: '#fff',
    areaColor: '#00CED1',
    areaHightColor: '#388498',
    borderWidth: 1,
    borderColor: '#fff',
    unit: '',
    animation: true,
    animationTime: 3000,
    visualMap: false,
    visualLeft: 5,
    visualTop: 40
  }
}

const cards = {
  col: 3,
  margin: 6,
  padding: 10,
  shadow: 'hover',
  textAlign: 'center'
}

export default [
  {
    title: '布局组件',
    type: 'layout',
    category: ['report'],
    list: [
      {
        type: 'grid',
        category: ['report'],
        label: '网格',
        prop: null,
        icon: 'xa-icon-grid',
        option: {
          ...auths,
          rows: 2,
          cols: 2,
          minRow: 1,
          maxRow: 5,
          minCol: 2,
          maxCol: 5,
          gap: 10,
          margin: 0,
          padding: 0,
          borderRadius: 0,
          backgroundColor: 'rgba(255,255,255,1)'
        },
        children: [],
        temp: []
      },
      {
        type: 'column',
        category: ['report'],
        label: '分栏',
        prop: null,
        icon: 'xa-icon-column',
        option: {
          ...auths,
          direction: 'row',
          cols: 2,
          leftCol: 12,
          rightCol: 12,
          minCol: 4,
          maxCol: 20,
          gap: 10,
          margin: 0,
          padding: 0,
          borderRadius: 0,
          backgroundColor: 'rgba(255,255,255,1)'
        },
        children: [],
        temp: []
      },
      {
        type: 'tabs',
        category: ['report'],
        label: '选项卡',
        prop: null,
        icon: 'xa-icon-tab',
        option: {
          ...auths,
          type: '',
          currentTab: '',
          position: 'top',
          margin: 0,
          padding: 0,
          backgroundColor: '#f7f7f7'
        },
        children: [
          {
            label: '标签项',
            name: null,
            children: []
          },
          {
            label: '标签项',
            name: null,
            children: []
          }
        ]
      },
      {
        type: 'condition',
        category: ['report'],
        label: '搜索',
        prop: null,
        icon: 'xa-icon-search',
        option: {
          ...auths,
          size: 'small',
          column: [],
          relationship: [],
          searchBtn: true,
          clearBtn: true
        }
      }
    ]
  },
  {
    title: '基础组件',
    type: 'base',
    category: ['report', 'screen'],
    list: [
      {
        type: 'report',
        category: ['report'],
        label: '列表',
        prop: null,
        icon: 'xa-icon-table',
        top: 0,
        left: 0,
        index: 0,
        width: ['100%', 800],
        height: ['auto', 200],
        apiId: '',
        option: {
          ...apis,
          ...auths,
          hide: false,
          size: 'small',
          align: 'center',
          stripe: false,
          border: true,
          showHeader: true,
          height: 'auto',
          maxHeight: 'auto',
          selection: true,
          index: false,
          columnBtn: false,
          buttons: [],
          page: false,
          title: '',
          titleColor: '#333',
          titleFontSize: 20,
          titleFontWeight: 'bolder'
        },
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 30, 40, 50],
          layout: 'total, sizes, prev, pager, next, jumper',
          background: true
        }
      },
      {
        type: 'scrollboad',
        category: ['screen'],
        label: '轮播表',
        prop: null,
        icon: 'xa-icon-table',
        top: 0,
        left: 0,
        index: 0,
        width: 600,
        height: 200,
        apiId: '',
        option: {
          ...apis,
          ...auths,
          ...colors,
          hide: false,
          index: false,
          indexHeader: '#',
          indexStyle: 'color',
          showHeader: true,
          headerFontSize: 14,
          headerFontWeight: 'normal',
          headerColor: '#fff',
          headerBackgroundColor: '#3b9cd9',
          rowFontSize: 14,
          rowColor: '#666',
          oddRowBackgroundColor: '#fafafa',
          evenRowBackgroundColor: '#fff',
          rowNum: 4,
          animation: false,
          animationTime: 4000,
          carousel: 'single'
        }
      },
      {
        type: 'card',
        category: ['report', 'screen'],
        label: '静态卡片',
        prop: null,
        icon: 'xa-icon-card',
        top: 0,
        left: 0,
        index: 0,
        width: ['100%', 600],
        height: ['auto', 75],
        apiId: '',
        option: {
          ...apis,
          ...auths,
          ...cards,
          hide: false
        }
      },
      {
        type: 'dynamic-card',
        category: ['report', 'screen'],
        label: '动态卡片',
        prop: null,
        icon: 'xa-icon-card',
        top: 0,
        left: 0,
        index: 0,
        width: ['100%', 600],
        height: ['auto', 75],
        apiId: '',
        option: {
          ...apis,
          ...auths,
          ...colors,
          ...cards,
          ...cardConfig.attrs,
          hide: false
        }
      },
      {
        type: 'border',
        category: ['screen'],
        label: '边框',
        prop: null,
        icon: 'xa-icon-border',
        width: 300,
        height: 300,
        option: {
          ...auths,
          hide: false,
          opacity: 1,
          angle: 0,
          borderType: 'image',
          borderRadius: 0,
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: '#3B9CD9',
          borderImage: 'data:image/png;base64,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',
          sliceTop: 0,
          sliceBottom: 0,
          sliceLeft: 0,
          sliceRight: 0,
          backgroundColor: 'rgba(255,255,255,0)'
        }
      },
      {
        type: 'image',
        category: ['report', 'screen'],
        label: '图片',
        prop: null,
        icon: 'xa-icon-image',
        width: 200,
        height: 150,
        option: {
          ...auths,
          hide: false,
          source: '',
          opacity: 1,
          borderRadius: 0,
          animation: false,
          animationTime: 1500,
          animationRotate: 'clockwise'
        }
      },
      {
        type: 'swiper',
        category: ['report', 'screen'],
        label: '轮播图',
        prop: null,
        icon: 'xa-icon-swiper',
        width: 600,
        height: 200,
        option: {
          ...apis,
          ...auths,
          hide: false,
          type: '',
          autoplay: true,
          loop: true,
          showIndicator: true,
          fullScreen: true,
          showTitle: true,
          duration: 5000,
          opacity: 1,
          direction: 'horizontal',
          indicatorPosition: 'outside',
          arrow: 'hover',
          textAlign: 'left',
          fontSize: 14,
          fontWeight: 'normal',
          color: '#333'
        }
      },
      {
        type: 'progress',
        category: ['report', 'screen'],
        label: '进度条',
        prop: null,
        icon: 'xa-icon-progress',
        width: 200,
        height: 200,
        option: {
          ...apis,
          ...auths,
          hide: false,
          type: 'circle',
          strokeWidth: 12,
          stroke: '#3b9cd9',
          percentage: 25,
          padding: 10,
          margin: 0,
          fontSize: 14,
          color: '#333'
        }
      },
      {
        type: 'text',
        category: ['report', 'screen'],
        label: '文本框',
        prop: null,
        icon: 'xa-icon-text',
        top: 0,
        left: 0,
        index: 0,
        width: 200,
        height: 36,
        option: {
          ...auths,
          hide: false,
          value: '数据报表',
          multiline: false,
          lineHeight: 36,
          margin: 10,
          padding: 0,
          split: 0,
          textAlign: 'left',
          fontSize: 20,
          fontWeight: 'normal',
          color: '#333',
          backgroundColor: 'rgba(255,255,255,0)',
          animation: false,
          animationTime: 100,
          ...hyperlink
        }
      },
      {
        type: 'datetime',
        category: ['report', 'screen'],
        label: '实时时间',
        prop: null,
        icon: 'xa-icon-datetime',
        top: 0,
        left: 0,
        index: 0,
        width: 200,
        height: 36,
        option: {
          ...auths,
          hide: false,
          margin: 0,
          padding: 0,
          split: 0,
          textAlign: 'left',
          fontSize: 20,
          fontWeight: 'normal',
          type: 'date',
          formater: 'YYYY-MM-DD',
          color: '#333',
          backgroundColor: 'rgba(255,255,255,0)'
        }
      },
      {
        type: 'iframe',
        category: ['report', 'screen'],
        label: 'iframe',
        prop: null,
        icon: 'xa-icon-iframe',
        width: ['100%', 600],
        height: 200,
        option: {
          ...auths,
          hide: false,
          source: ''
        }
      },
      {
        type: 'button',
        category: ['report'],
        label: '按钮',
        prop: null,
        icon: 'xa-icon-button',
        width: '100%',
        height: 'auto',
        option: {
          ...auths,
          hiden: false,
          align: 'center',
          device: '',
          column: [
            {
              ...buttonConfig.attrs,
              text: '确定'
            }
          ]
        }
      }
      // {
      //   type: 'slot',
      //   category: ['screen'],
      //   label: '插槽',
      //   prop: null,
      //   icon: 'xa-icon-slot',
      //   width: [200],
      //   height: [100],
      //   option: {
      //     hide: false,
      //     slotName: ''
      //   }
      // }
    ]
  },
  {
    title: '统计组件',
    type: 'echart',
    category: ['report', 'screen'],
    list: [
      {
        type: 'echart-bar',
        category: ['report', 'screen'],
        label: '柱状图',
        prop: '',
        icon: 'xa-icon-bar',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'bar',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.grid,
          ...echarts.legend,
          ...echarts.label,
          ...echarts.tooltip,
          ...echarts.xAxis,
          ...echarts.yAxis,
          ...hyperlink,
          barWidth: 16,
          barMinHeight: 0
        }
      },
      {
        type: 'echart-line',
        category: ['report', 'screen'],
        label: '折线图',
        prop: '',
        icon: 'xa-icon-line',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'line',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.grid,
          ...echarts.legend,
          ...echarts.label,
          ...echarts.tooltip,
          ...echarts.xAxis,
          ...echarts.yAxis,
          ...hyperlink,
          lineWidth: 1,
          symbolSize: 2,
          smooth: true,
          areaStyle: false
        }
      },
      {
        type: 'echart-pie',
        category: ['report', 'screen'],
        label: '饼图',
        prop: '',
        icon: 'xa-icon-pie',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'pie',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.center,
          ...echarts.legend,
          ...echarts.label,
          ...echarts.tooltip,
          ...hyperlink,
          borderRadius: 0,
          borderColor: '#fff',
          borderWidth: 0,
          radius: false,
          roseType: false,
          sort: false,
          notCount: false,
          activeLeft: 50,
          activeTop: 50,
          activeTitleFontSize: 12,
          activeTitleColor: '#666',
          activeValueFontSize: 16,
          activeValueColor: '#3B9CD9',
          animation: false,
          animationTime: 4000
        }
      },
      {
        type: 'echart-funnel',
        category: ['report', 'screen'],
        label: '漏斗图',
        prop: '',
        icon: 'xa-icon-funnel',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'funnel',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.legend,
          ...echarts.label,
          ...echarts.tooltip,
          ...hyperlink,
          labelLine: false,
          sort: false,
          notCount: false
        }
      },
      {
        type: 'echart-radar',
        category: ['report', 'screen'],
        label: '雷达图',
        prop: '',
        icon: 'xa-icon-radar',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'radar',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.center,
          ...echarts.legend,
          ...echarts.label,
          ...echarts.tooltip,
          ...hyperlink,
          shape: 'polygon',
          nameFontSize: 10,
          nameColor: '#333',
          areaOpacity: 0
        }
      },
      {
        type: 'echart-gauge',
        category: ['report', 'screen'],
        label: '仪表盘',
        prop: '',
        icon: 'xa-icon-gauge',
        top: 30,
        left: 50,
        index: 0,
        width: ['100%', 600],
        height: 300,
        apiId: '',
        option: {
          type: 'gauge',
          hide: false,
          conditionId: null,
          ...apis,
          ...auths,
          ...colors,
          ...echarts.title,
          ...echarts.center,
          ...echarts.gauge,
          ...hyperlink
        }
      }
    ]
  }
]
